import axios from 'axios';

export default {

    //Permet de récuperer les notifications de l'utilisateur connecté
    get() {
        return axios.get(process.env.VUE_APP_API_URI + '/api/notifications/list');
    }
}
